module.exports = __webpack_public_path__ + "img/meeting-fliph.79e697cb.png";